export default "__VITE_ASSET__Dl6FNb6d__"